var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ viewBox: "0 0 21 21", fill: "none" }, props),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6.648 5.594l4.17 5.15-4.252 4.67-1.48-1.348 3.096-3.398-3.088-3.816 1.554-1.258zM13.5 15V6h2v9h-2z", fill: "#354147" }),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M19 2H2v17h17V2zM0 0v21h21V0H0z", fill: "#354147" })
  );
});